// components/LSSF/BaseList.jsx
import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ToastContainer, toast } from 'react-toastify';

import axios from 'axios';
import { MdDelete, MdEditSquare, MdSearch } from 'react-icons/md';
import { Link } from 'react-router-dom';

const BaseList = ({ 
  title, 
  apiEndpoint, 
  columns, 
  addButtonLink, 
  addButtonText,
  renderCustomRow 
}) => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const limit = 20;

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${base_url}${apiEndpoint}`);
      setData(res.data.data);
      setFilteredData(res.data.data);
      setTotalPages(res.data.pagination?.totalPages || 1);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching data:', err);
      toast.error('Failed to fetch data');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page]);

  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredData(data);
    } else {
      const searchLower = searchTerm.toLowerCase();
      const filtered = data.filter(item => {
        return columns.some(column => {
          const value = item[column.key];
          if (value && typeof value === 'string') {
            return value.toLowerCase().includes(searchLower);
          } else if (value && typeof value === 'number') {
            return value.toString().includes(searchLower);
          }
          return false;
        });
      });
      setFilteredData(filtered);
    }
  }, [searchTerm, data]);

  const deleteHandler = async (id) => {
    const choice = window.confirm('Are you sure you want to delete?');
    if (choice) {
      try {
        await axios.delete(`${base_url}${apiEndpoint}/${id}`);
        toast.success('Deleted successfully');
        fetchData();
      } catch (err) {
        console.error('Delete error:', err);
        toast.error('Failed to delete');
      }
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header row d-flex justify-content-between align-items-center">
                <div className="col-md-4">
                  <h4 className="mb-0">{title}</h4>
                </div>
                {/* <div className="col-md-4">
                  <div className="input-group">
                    <span className="input-group-text">
                      <MdSearch />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                </div> */}
                {/* <div className="col-md-4 text-end">
                  <Link to={addButtonLink} className="btn btn-primary btn-sm">
                    + {addButtonText}
                  </Link>
                </div> */}
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered shadow-sm mt-3" cellPadding={5}>
                    <thead>
                      <tr>
                        <th>S.No.</th>
                        {columns.map((col, idx) => (
                          <th key={idx}>{col.label}</th>
                        ))}
                        <th>Created At</th>
                        {/* <th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          {[...Array(columns.length + 3)].map((_, i) => (
                            <td key={i}><Skeleton count={1} /></td>
                          ))}
                        </tr>
                      ) : filteredData.length > 0 ? (
                        filteredData.map((item, index) => (
                          renderCustomRow ? (
                            renderCustomRow(item, index, page, limit, deleteHandler)
                          ) : (
                            <tr key={item.id}>
                              <td>{(page - 1) * limit + index + 1}</td>
                              {columns.map((col, idx) => (
                                <td key={idx}>
                                  {col.render ? col.render(item[col.key], item) : item[col.key]}
                                </td>
                              ))}
                              <td>{new Date(item.created_at).toLocaleDateString()}</td>
                              {/* <td>
                                <Link to={`${addButtonLink}/${item.id}`}>
                                  <MdEditSquare size={24} style={{ color: 'green', cursor: 'pointer' }} />
                                </Link>
                                <button className="btn" onClick={() => deleteHandler(item.id)}>
                                  <MdDelete size={24} style={{ color: 'red' }} />
                                </button>
                              </td> */}
                            </tr>
                          )
                        ))
                      ) : (
                        <tr className="text-center text-danger">
                          <td colSpan={columns.length + 3}>No data found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Pagination Controls */}
                {/* <div className="d-flex justify-content-center align-items-center gap-3 mt-4">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                  >
                    Previous
                  </button>
                  <span>Page {page} of {totalPages}</span>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={page === totalPages}
                    onClick={() => setPage(page + 1)}
                  >
                    Next
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default BaseList;